module.exports = __webpack_public_path__ + "img/modelo_small3.8e9e5d16.png";